module.exports = __webpack_public_path__ + "static/sofa-0cdf7b3c3c39bba707f38f2632441db9.png";